export default __webpack_public_path__ + "static/media/sanmar23.ddf4c535.jpg";